import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppNavigationService } from '@app/services/app-navigation.service';
import { AppRouteService } from '@app/services/app-route.service';
import { AppService } from '@app/services/app.service';
import { UserService } from '@app/services/user.service';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';

export const LoginGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const userService = inject(UserService);
    const appService: AppService = inject(AppService);
    const appRouteService: AppRouteService = inject(AppRouteService);
    const appNavigationService = inject(AppNavigationService);

    return toObservable(appService.loading).pipe(
        filter(loading => !loading),
        map(loading => {
            if (userService.isLoggedIn() && userService.user().hasRole) {
                appNavigationService.navigateTo(appRouteService.defaultRoute);
                return false;
            }

            return true;
        }),
    );
};
